module.exports = __webpack_public_path__ + "img/2.8aa24800.jpg";